import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=7bdb5766&scoped=true&"
import script from "./TaskManager.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskManager.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb5766",
  null
  
)

export default component.exports